<div
  class="thi-landing-root min-h-screen bg-background text-foreground"
  [attr.dir]="dir"
  [class.font-inter]="fontClass === 'font-inter'"
  [class.font-cairo]="fontClass === 'font-cairo'"
  [class.font-heebo]="fontClass === 'font-heebo'"
>
  <app-thi-landing-header [lang]="landingLang"></app-thi-landing-header>
  <app-thi-landing-main [lang]="landingLang"></app-thi-landing-main>
  <app-thi-landing-footer [lang]="landingLang"></app-thi-landing-footer>
</div>
